module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-support-buttons-item-bg-1-46c22f6632f3e569a105fc1128c38985.png";